import React from "react";
import Navbar from "../features/Navbar/Navbar";
import ForgotPassword from "../features/Auth/Component/ForgotPassword";

export default function ForgotPasswordPage() {
  return (
    <>
      <Navbar></Navbar>
      <ForgotPassword></ForgotPassword>
    </>
  );
}
